/* eslint-disable react/prop-types */
import React, { useState, useCallback, useRef } from "react";
import { ReactSVG } from "react-svg";
import bookmarkIcon from "src/files/bookmark.svg";

export const BookmarkButton = ({ data }) => {
  const isBookmarked = window.squiz.fn.BookmarkStorage.isBookmarked(data?.id);

  const [active, setActive] = useState(isBookmarked);
  const buttonRef = useRef(null);

  const handleClick = useCallback(() => {
    const newActive = window.squiz.fn.BookmarkStorage.toggleBookmark(data);
    setActive(newActive);
    // Note: Tracking is handled by layoutTracking.js bookmarkTracking() function
    // to avoid duplicate GTM events
  }, [data]);

  return (
    <>
      <button
        ref={buttonRef}
        className={`bookmark rec-card-hero__bookmark ${active ? "active" : ""}`}
        id={`bookmark_${data.id}`}
        type="button"
        aria-controls="control-bookmark"
        aria-label={`Bookmark for ${data.name}`}
        aria-pressed={active ? true : false}
        onClick={handleClick}
      >
        <ReactSVG src={bookmarkIcon} wrapper={"svg"} />
      
      </button>
    </>
  );
};
